// Action Types
export const FETCH_NEXT_STEP_CARD_REQUEST = "FETCH_NEXT_STEP_CARD_REQUEST";
export const FETCH_NEXT_STEP_CARD_SUCCESS = "FETCH_NEXT_STEP_CARD_SUCCESS";
export const FETCH_NEXT_STEP_CARD_FAILURE = "FETCH_NEXT_STEP_CARD_FAILURE";

// Action Creators
export const fetchNextStepCardRequest = ({opportunityId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_NEXT_STEP_CARD_REQUEST,
      payload: {opportunityId},
    });
  };
};
export const fetchNextStepCardSuccess = (data) => ({
  type: FETCH_NEXT_STEP_CARD_SUCCESS,
  payload: data,
});
export const fetchNextStepCardFailure = (error) => ({
  type: FETCH_NEXT_STEP_CARD_FAILURE,
  payload: error,
});
